export const defaultRevalidate = () => false;
